import React, { useContext, useEffect, useState } from 'react'
import { AiFillShopping, AiOutlineShoppingCart } from 'react-icons/ai'
import { BsFillCreditCard2BackFill } from 'react-icons/bs'
import "./Checkout.css"
import { Link} from 'react-router-dom';
import CheckoutProducts from './CheckoutProducts/CheckoutProducts';
import { Context } from '../../utils/context';
import { BiSolidLock } from 'react-icons/bi';
import { MdCall, MdOutlineSecurity } from 'react-icons/md';
import logo from "./images/creativity letter-circle.png"
import axios from 'axios';



declare global {
  interface Window {
    Razorpay: any; 
  }
}


function Checkout() {
  
  const [selectedCountry, setSelectedCountry] = useState('United States');
  const [fName,setFName] = useState('');
  const [lName,setLName] = useState('');
  const [email,setEmail] = useState('');
  const [address,setAddress] = useState('');
  const [state, setState] = useState('');
  const [city,setCity] = useState('');
  const [zip,setZip] = useState("");
  const [phoneNo,setPhoneNo] = useState('');

  const handleCountryChange = (e: any) => {
    setSelectedCountry(e.target.value);
  };

  useEffect(() => {
    const phoneInputField = document.querySelector('#phone');
    if (phoneInputField) {
      // Use type assertion to indicate that 'intlTelInput' exists on 'window'
      const phoneInput = (window as any).intlTelInput(phoneInputField, {
        utilsScript:
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
      });
    }
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  
    script.onload = () => {
      // Now you can use razor.open
    };
  
    return () => {
      // Clean up the script if needed
      document.body.removeChild(script);
    };
  }, []);

  const {cartItems, cartSubTotal} = useContext(Context);


  const checkoutHandler = async (amount: Number, e:React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const { data: { key } } = await axios.get(`${process.env.REACT_APP_API}/api/getkey`)

    const { data: { order } } = await axios.post(`${process.env.REACT_APP_API}/api/checkout`, {
        amount
    })

    const products = !!cartItems?.length && cartItems.map((item: any) => ({
      quantity: item.attributes.quantity,
      title: item.attributes.title,
      price: item.attributes.price,
    }));  

    const totalPrice = cartSubTotal;
    
    const name = fName + "" + lName;
    const options = {
        key: key,
        amount: order.amount,
        currency: "INR",
        name: "Xiel Store",
        description: "Payment-Gateway",
        image: logo,
        order_id: order.id,
        callback_url: `${process.env.REACT_APP_API}/api/paymentverification`,
        prefill: {
            name: fName + "" + lName,
            email: email,
            contact: phoneNo
        },
        notes: {
            "address": "Razorpay Corporate Office"
        },
        theme: {
            "color": "#121212"
        }
    };
    const razor = new window.Razorpay(options);
    razor.open();

    axios.post(`${process.env.REACT_APP_API}/api/paymentsuccess`, {
          name,
          email,
          selectedCountry,
          state,
          city,
          address,
          zip,
          phoneNo,
          products,
          totalPrice,
    })
  }

  return (
    <>
    <div className='review-back-container' id='checkout-back-container'>
      <div className="review-main-container">
        <div className="upper-content">
          <span id='review-heading'>Cart</span>
          <div className="loading-container">
            <div className="shop-container">
              <div className='review-icon-container'>
                <AiFillShopping />
              </div>
              <span>Shop</span>
            </div>
            <div className="hr-line"></div>
            <div className="shop-container" >
              <div className='review-icon-container'>
                <AiOutlineShoppingCart />
              </div>
              <span>Review</span>
            </div>
            <div className="hr-line"></div>
            <div className="shop-container" id="active-page">
              <div className='review-icon-container'>
                <BsFillCreditCard2BackFill />
              </div>
              <span>Checkout</span>
            </div>
          </div>
        </div>
        <div className="checkout-form-container">
        <div className="overview-container" id='res-overview-container'>
              {!!cartItems?.length && <>
                <div className="order-heading">
                  <p className='order-heading-text'>Order Summary</p><Link to="/review">Edit Cart</Link>
                </div>
                <div className="overview-total">
                  <table>
                    <tbody>
                      <tr>
                        <th>Subtotal</th>
                        <td>&#8377;{cartSubTotal}</td>
                      </tr>
                      <tr>
                        <th>Shipping</th>
                        <td>&#8377;0</td>
                      </tr>
                      <tr>
                        <th>Total</th>
                        <td>&#8377;{cartSubTotal}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="overview-prod-container">
                  <CheckoutProducts />
                </div>
              </>}
            </div>
          <h4>Ship To</h4>
          <div className="input-container">
            <form action="">
              <div className="input-content">
                <p>Country</p>
                <select className='country-input' value={selectedCountry} onChange={handleCountryChange}>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="American Samoa">American Samoa</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antartica">Antarctica</option>
                  <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermuda">Bermuda</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia and Herzegowina">Bosnia and Herzegowina</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Bouvet Island">Bouvet Island</option>
                  <option value="Brazil">Brazil</option>
                  <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                  <option value="Brunei Darussalam">Brunei Darussalam</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Cayman Islands">Cayman Islands</option>
                  <option value="Central African Republic">Central African Republic</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Christmas Island">Christmas Island</option>
                  <option value="Cocos Islands">Cocos (Keeling) Islands</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo">Congo</option>
                  <option value="Congo">Congo, the Democratic Republic of the</option>
                  <option value="Cook Islands">Cook Islands</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Cota D'Ivoire">Cote d'Ivoire</option>
                  <option value="Croatia">Croatia (Hrvatska)</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="East Timor">East Timor</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Falkland Islands">Falkland Islands (Malvinas)</option>
                  <option value="Faroe Islands">Faroe Islands</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="France Metropolitan">France, Metropolitan</option>
                  <option value="French Guiana">French Guiana</option>
                  <option value="French Polynesia">French Polynesia</option>
                  <option value="French Southern Territories">French Southern Territories</option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Greece">Greece</option>
                  <option value="Greenland">Greenland</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guadeloupe">Guadeloupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Heard and McDonald Islands">Heard and Mc Donald Islands</option>
                  <option value="Holy See">Holy See (Vatican City State)</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran">Iran (Islamic Republic of)</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Democratic People's Republic of Korea">Korea, Democratic People's Republic of</option>
                  <option value="Korea">Korea, Republic of</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Lao">Lao People's Democratic Republic</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon" >Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Macau">Macau</option>
                  <option value="Macedonia">Macedonia, The Former Yugoslav Republic of</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Martinique">Martinique</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia">Micronesia, Federated States of</option>
                  <option value="Moldova">Moldova, Republic of</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="Netherlands Antilles">Netherlands Antilles</option>
                  <option value="New Caledonia">New Caledonia</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk Island">Norfolk Island</option>
                  <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Pitcairn">Pitcairn</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Reunion">Reunion</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russian Federation</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                  <option value="Saint LUCIA">Saint LUCIA</option>
                  <option value="Saint Vincent">Saint Vincent and the Grenadines</option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia (Slovak Republic)</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Georgia">South Georgia and the South Sandwich Islands</option>
                  <option value="Span">Spain</option>
                  <option value="SriLanka">Sri Lanka</option>
                  <option value="St. Helena">St. Helena</option>
                  <option value="St. Pierre and Miguelon">St. Pierre and Miquelon</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Svalbard">Svalbard and Jan Mayen Islands</option>
                  <option value="Swaziland">Swaziland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syrian Arab Republic</option>
                  <option value="Taiwan">Taiwan, Province of China</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania, United Republic of</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Turks and Caicos">Turks and Caicos Islands</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">United Arab Emirates</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="United States">United States</option>
                  <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Viet Nam</option>
                  <option value="Virgin Islands (British)">Virgin Islands (British)</option>
                  <option value="Virgin Islands (U.S)">Virgin Islands (U.S.)</option>
                  <option value="Wallis and Futana Islands">Wallis and Futuna Islands</option>
                  <option value="Western Sahara">Western Sahara</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
              </div>
              <div className="name-container">
                <div className="f-name input-content">
                  <div className="input-text">
                    <p>First Name</p><p className='required'>*required</p>
                  </div>
                  <input type="text" value={fName} onChange={(e) => setFName(e.target.value)} />
                </div>
                <div className="l-name input-content">
                  <div className="input-text">
                    <p>Last Name</p><p className='required'>*required</p>
                  </div>
                  <input type="text" value={lName} onChange={(e) => setLName(e.target.value)} />
                </div>
              </div>
              <div className="input-content">
                <div className="input-text">
                  <p>Email</p><p className='required'>*required</p>
                </div>
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div className="input-content">
                <div className="input-text">
                  <p>Address</p><p className='required'>*required</p>
                </div>
                <input type="text" className='address-input' value={address} onChange={(e) => setAddress(e.target.value)}/>
              </div>
              <div className="state-container">
                <div className="city-container">
                  <div className="f-name input-content">
                    <p>City</p>
                    <input type="text" className='state' value={city} onChange={(e) => setCity(e.target.value)} />
                  </div>
                  <div className="f-name input-content">
                    <p>State</p>
                    <input type="text" className='state' value={state} onChange={(e) => setState(e.target.value)} />
                  </div>    
                </div>
                <div className="f-name input-content">
                  <p>Zip</p>
                  <input type="text" className='state' value={zip} onChange={(e) => setZip(e.target.value)} />
                </div>
              </div>
              <div className="input-content end-container">
                <div className="input-text">
                  <p>Phone Number</p><p className='required'>*required</p>
                </div>
                <input id="phone" type="tel" name="phone" value={phoneNo} onChange={(e) => setPhoneNo(e.target.value)} />
              </div>
              <div className="proceed-btn-container">
                <button className="proceed-btn" onClick={(e) => checkoutHandler(cartSubTotal, e)}>Proceed Payment</button>
              </div>
            </form>
            <div className="overview-container">
              {!!cartItems?.length && <>
                <div className="order-heading">
                  <p className='order-heading-text'>Order Summary</p><Link to="/review">Edit Cart</Link>
                </div>
                <div className="overview-total">
                  <table>
                    <tbody>
                      <tr>
                        <th>Subtotal</th>
                        <td>&#8377;{cartSubTotal}</td>
                      </tr>
                      <tr>
                        <th>Shipping</th>
                        <td>&#8377;0</td>
                      </tr>
                      <tr>
                        <th>Total</th>
                        <td>&#8377;{cartSubTotal}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="overview-prod-container">
                  <CheckoutProducts />
                </div>
              </>}
            </div>
          </div>
        </div>
        <div className="lower-content">
          <div className="usp-container">
            <BiSolidLock />
            <div className="usp-heading">
              <h4>Your Information Is Safe</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>
          <div className="usp-container">
            <MdOutlineSecurity />
            <div className="usp-heading">
              <h4>Secure Checkout</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>  
          <div className="usp-container">
            <MdCall />
            <div className="usp-heading">
              <h4>24/7 Customer Support</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</>
  )
}

export default Checkout
